//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Theme from '@/listing-app/mixins/Theme'
import TooltipControl from '@/listing-app/mixins/TooltipControl'
import Tooltip from '@/listing-app/components/detail/Tooltip'
export default {
	name: "Layouts",
	mixins: [Theme, TooltipControl],
	props: ["data", "tooltips", "layout"],
  components: {
    appTooltip: Tooltip
  },
  data() {
		return { }
	},
  methods: {
		check_price_mask(item) {
			return !!item.PriceMask
		},
    set_layout(payload) {
			this.$emit("setLayout", payload)
    }
  }
}
